/**
 * Authorization Subscriptions
 */
export const AuthSubscriptions = {
  free: ['free', 'first', 'second', 'third', 'trial'],
  first: ['first', 'second', 'third', 'trial'],
  second: ['second', 'third', 'trial'],
  third: ['third', 'trial'],
  trial: ['trial'],
};
